import * as maplibregl from "maplibre-gl";
import { map } from "scripts/map/map";

export const MARKER_RED_COLOR = '#ff6b6b';
export const MARKER_BLUE_COLOR = "#2196f3";


export class Marker {
    public lat: number;
    public lng: number;

    public isActive: boolean = false;
    public sectorData: any;

    private marker: maplibregl.Marker | null = null;

    constructor(lat: number, lng: number, sectorData?: any, isActive: boolean = false) {
        this.lat = lat;
        this.lng = lng;
        this.sectorData = sectorData;
        this.isActive = isActive;
        console.log('Marker создан с данными:', sectorData);
    }

    public draw() {
        this.marker = new maplibregl.Marker({ color: this.isActive ? MARKER_RED_COLOR : MARKER_BLUE_COLOR })
            .setLngLat([this.lng, this.lat])
            .addTo(map);

        // Добавляем попап
        this.attachSectorPopup();
    }

    public redraw() {
        this.marker?.setLngLat([this.lng, this.lat]);
    }

    public remove() {
        this.marker?.remove();
    }

    public activate(){
        const path = this.getPath();
        if(!path) return;
        path.setAttribute("fill", MARKER_RED_COLOR);
    }

    public deactivate(){
        const path = this.getPath();
        if(!path) return;
        path.setAttribute("fill", MARKER_BLUE_COLOR);
    }


    private getPath() {
        if(!this.marker) 
            return;
        let element = this.marker.getElement();
        let svg = element.getElementsByTagName("svg")[0];
        let path = svg.getElementsByTagName("path")[0];
        return path;
    }

    /**
     * Попап при нажатии на маркер
     * @param marker 
     * @param sector 
     */
    private attachSectorPopup() {
        console.log('attachSectorPopup вызван, sectorData:', this.sectorData);
        const data = this.sectorData || {};
        console.log('Данные для попапа:', data);
        const azimuth = data.azimuth !== undefined && data.azimuth !== null 
            ? data.azimuth.toFixed(1)  // Азимут с одним знаком после запятой
            : '—';
            
        const distance = data.distance !== undefined && data.distance !== null 
            ? data.distance.toFixed(0)  // Дистанция целым числом
            : '—';
            
        const angle = data.angle !== undefined && data.angle !== null 
            ? data.angle  // Угол
            : '—';
        
        const popupHtml = `
            <div style="
                min-width:220px;
                font-family: system-ui, -apple-system, sans-serif;
                color:#222;
            ">
                <div style="
                    font-weight:600;
                    font-size:14px;
                    margin-bottom:8px;
                    border-bottom:1px solid #eee;
                    padding-bottom:4px;
                ">
                    📡 Датчик: ${data.name || 'Без названия'}
                </div>

                <div style="display:flex; flex-direction:column; gap:4px; font-size:13px;">
                    <div style="display:flex; justify-content:space-between;">
                        <span style="color:#666;">Азимут</span>
                        <span>${azimuth}°</span>
                    </div>
                    <div style="display:flex; justify-content:space-between;">
                        <span style="color:#666;">Дистанция</span>
                        <span>${distance} m</span>
                    </div>
                    <div style="display:flex; justify-content:space-between;">
                        <span style="color:#666;">Угол</span>
                        <span>${angle}°</span>
                    </div>

                    <div style="margin-top:6px; border-top:1px solid #eee; padding-top:6px;">
                        <div style="display:flex; justify-content:space-between;">
                            <span style="color:#666;">Широта</span>
                            <span>${this.lat.toFixed(6)}</span>
                        </div>
                        <div style="display:flex; justify-content:space-between;">
                            <span style="color:#666;">Долгота</span>
                            <span>${this.lng.toFixed(6)}</span>
                        </div>
                    </div>
                </div>
            </div>
            `;
    
        const popup = new maplibregl.Popup({
            offset: 25,
            closeButton: true
        }).setHTML(popupHtml);
    
        this.marker?.setPopup(popup);
    }
}